import Image from "next/image";
import { about } from "../../../shared/utils/faq";
import Collapsible from "react-collapsible";
import styles from "../faq.module.scss";

export default function AboutKenzie() {
  const handleOpen = (index: number) => {
    const arrow = document.querySelector(`.arrowAbout${index}`);
    arrow?.classList.toggle(styles.active);
  };
  return (
    <div className={styles.questionWrapper} data-aos="fade-down">
      <h2 className={styles.title}>01. Sobre a Kenzie Academy</h2>

      {about.map((item, index) => (
        <div key={`${item.title + index}`}>
          <Collapsible
            trigger={
              <div
                className={styles.questionTitle}
                onClick={() => handleOpen(index)}
              >
                <h3>{item.title}</h3>
                <Image
                  src="/images/arrow-down.svg"
                  alt="Ícone de pergunta"
                  width="23"
                  height="14"
                  className={`arrowAbout${index}`}
                />
              </div>
            }
            className={styles.dropdown}
          >
            <article className={styles.question}>
              <div>
                <p>{item.paragraph}</p>
              </div>
            </article>
          </Collapsible>
        </div>
      ))}
    </div>
  );
}
